import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect } from "react";
import classnames from "classnames";
import Dialog from "@mui/material/Dialog";
import { useIsInsideContainer } from "../hooks/index.js";
import { useStyles } from "./Dialog.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function Dialog_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else Dialog_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const SCROLLABLE_DIALOG_ID = 'scrollable-dialog';
const Dialog_Dialog = (t0)=>{
    const $ = c(15);
    const { fullScreen: t1, withoutRadius, width, bottomIslandSpace, children, classes, open } = t0, props = _object_without_properties(t0, [
        "fullScreen",
        "withoutRadius",
        "width",
        "bottomIslandSpace",
        "children",
        "classes",
        "open"
    ]);
    const fullScreen = void 0 === t1 ? false : t1;
    let t2;
    if ($[0] !== width) {
        t2 = {
            width
        };
        $[0] = width;
        $[1] = t2;
    } else t2 = $[1];
    const { classes: styles } = useStyles(t2);
    const isInsideContainer = useIsInsideContainer();
    const t3 = null == classes ? void 0 : classes.paper;
    const t4 = withoutRadius && styles.dialogWithoutRadius;
    const t5 = bottomIslandSpace && styles.bottomIslandSpace;
    let t6;
    if ($[2] !== styles.dialogPaper || $[3] !== t3 || $[4] !== t4 || $[5] !== t5) {
        t6 = classnames(styles.dialogPaper, t3, t4, t5);
        $[2] = styles.dialogPaper;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== classes || $[8] !== t6) {
        t7 = _object_spread_props(_object_spread({}, classes), {
            paper: t6
        });
        $[7] = classes;
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    const modalClasses = t7;
    let t8;
    let t9;
    if ($[10] !== isInsideContainer || $[11] !== open) {
        t8 = ()=>{
            if (isInsideContainer) document.body.style.overflow = open ? "hidden" : "";
            return ()=>{
                if (isInsideContainer) document.body.style.overflow = "";
            };
        };
        t9 = [
            open,
            isInsideContainer
        ];
        $[10] = isInsideContainer;
        $[11] = open;
        $[12] = t8;
        $[13] = t9;
    } else {
        t8 = $[12];
        t9 = $[13];
    }
    useEffect(t8, t9);
    if (open) {
        let t10;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
            t10 = {
                id: SCROLLABLE_DIALOG_ID
            };
            $[14] = t10;
        } else t10 = $[14];
        return /*#__PURE__*/ jsx(Dialog, _object_spread_props(_object_spread({
            classes: modalClasses,
            fullScreen: fullScreen,
            className: classnames("aqa_dialog", props.className),
            open: open,
            "data-testid": "dialog-test-id",
            PaperProps: t10
        }, props), {
            children: children
        }));
    }
    return null;
};
export { Dialog_Dialog as Dialog };
